"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlightPassengerListHeader = void 0;
const react_1 = __importDefault(require("react"));
require("./index.scss");
const className = 'flight-passenger-list-header';
class FlightPassengerListHeader extends react_1.default.PureComponent {
    render() {
        return (react_1.default.createElement("div", { className: className },
            this.props.leftComponent && (react_1.default.createElement("div", { className: `${className}__left` }, this.props.leftComponent)),
            this.props.rightComponent && (react_1.default.createElement("div", { className: `${className}__right` }, this.props.rightComponent))));
    }
}
exports.FlightPassengerListHeader = FlightPassengerListHeader;
//# sourceMappingURL=index.js.map